import { Modal, Form, Input, Checkbox, message, Space } from 'antd';
import { useWisecureMutation } from '@wisecure/api-client/hooks';
import { neutral } from '@/theme';

interface NotificationPopupProps {
  open: boolean;
  onClose: () => void;
  userIds: string[];
}

export function NotificationPopup({ open, onClose, userIds }: NotificationPopupProps) {
  const [form] = Form.useForm();

  const sendMutation = useWisecureMutation(
    (client, values: { title: string; htmlBody: string; sendPush: boolean; pushBody?: string }) =>
      client.dashboard.dashboardControllerSendNotifications({
        requestBody: {
          userIds,
          title: values.title,
          htmlBody: values.htmlBody,
          sendPush: values.sendPush,
          pushBody: values.pushBody,
        },
      }),
    {
      onSuccess: () => {
        message.success('Notifications envoyées');
        form.resetFields();
        onClose();
      },
      onError: () => message.error("Erreur lors de l'envoi des notifications"),
    },
  );

  const handleOk = () => {
    form.validateFields().then((values) => {
      sendMutation.mutate(values);
    });
  };

  return (
    <Modal
      title="Envoyer des notifications"
      open={open}
      onCancel={onClose}
      onOk={handleOk}
      confirmLoading={sendMutation.isPending}
      okText="Envoyer"
      cancelText="Annuler"
      destroyOnHidden
    >
      <Form form={form} layout="vertical" initialValues={{ sendPush: true }}>
        <Form.Item name="title" label="Titre" rules={[{ required: true, message: 'Champ requis' }]}>
          <Input placeholder="Titre de la notification" />
        </Form.Item>
        <Form.Item name="htmlBody" label="Message" rules={[{ required: true, message: 'Champ requis' }]}>
          <Input.TextArea rows={4} placeholder="Corps du message..." />
        </Form.Item>
        <Space direction="vertical">
          <Form.Item name="sendPush" valuePropName="checked" noStyle>
            <Checkbox>Envoyer une notification push</Checkbox>
          </Form.Item>
          <Form.Item name="pushBody" label="Message push (optionnel)">
            <Input.TextArea rows={2} placeholder="Message pour la notification push..." />
          </Form.Item>
        </Space>
      </Form>
      <div style={{ marginTop: 8, color: neutral[300] }}>
        {userIds.length} destinataire(s) sélectionné(s)
      </div>
    </Modal>
  );
}
